import logo from './logo.svg';
import './App.css';
import toast, { Toaster } from 'react-hot-toast';
import { BrowserRouter, Navigate, Outlet, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "./Redux/Actions/userAction";
import Content from "./views/content/Content";
import Login from "./views/login/Login";
import Register from "./views/login/Register";
import User from "./views/user/User";
import Screen from "./views/screen/Screen";
import Playlist from "./views/playlist/Playlist";
import PlaylistDetails from "./views/playlist/PlaylistDetails";
import PlaylistPlayer from "./views/playlist/PlaylistPlayer";
import ForgetPassword from "./views/login/ForgetPassword";
import Dashboard from "./views/dashboard/Dashboard";
import Setting from "./views/setting/Setting";
import { socketInit } from './socket';
import PrivacyPolicy from './views/privacypolicy/PrivacyPolicy';
import ChangePassword from './views/login/ChangePassword';
import { useRefreshLogin } from './hooks/useRefreshLogin';
import { Box } from '@mui/material';
// Logo is now in public/images/notiz-logo.png - no need to import
// import Sharing from './views/sharing/Sharing';
import UserPanel from './views/user/UserPanel';
import DesignEditor from './designeditor/Index';
import LayoutList from './views/layout/LayoutList';
import axios from 'axios';
import { pdfjs } from 'react-pdf';
import Loader from './components/loader/Loader';
import ApkManage from './views/apkmanage/ApkManage';
import ScreenBandwidth from './views/bandwidth/ScreenBandwidth';
import { screenSocketOnline, screenSocketOffline } from './Redux/Actions/screenAction';
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
const events = [
  "load",
  "mousemove",
  "mousedown",
  "click",
  "scroll",
  "keypress",
];
// starting server 
// return
function App() {
  const dispatch = useDispatch();
  const { user, auth } = useSelector((state) => state.User);
  const location=useLocation();
  const { loading } = useRefreshLogin();
  console.log(location.pathname);
  let timer;
  const handleLogoutTimer = () => {
    timer = setTimeout(() => {
      resetTimer();
      Object.values(events).forEach((item) => {
        window.removeEventListener(item, resetTimer);
      });
      // if(!location.pathname.startsWith('/playlist-player'))
      // logoutAction();
    }, 1 * 60 * 1000);
  };
  const resetTimer = () => {
    if (timer) clearTimeout(timer);
  };
  useEffect(() => {
    Object.values(events).forEach((item) => {
      window.addEventListener(item, () => {
        resetTimer();
        handleLogoutTimer();
      });
    });
  }, []);
  const logoutAction = () => {
    // resetTimer();
    socketRef.current?.emit('leaving--connection')
    dispatch(logout())
    // window.location.pathname = "/login";
  };


  const socketRef = useRef();
  function __server__start(){
    console.log('starting...')
  }
  useEffect(() => {
    const socket = socketInit();
    socketRef.current = socket;

    // CMS is not a signage device — do not emit `join` here (that map slot is for players only).

    socket.on('screen', () => {});
    socket.on('message_recieved', ({ message }) => {
      if (message) {
        toast.success('message successfully');
      }
    });
    socket.on('admin_screen', ({ detail }) => {
      if (detail?.mac) dispatch(screenSocketOnline(detail.mac));
    });
    socket.on('leave', (obj) => {
      if (obj?.mac) dispatch(screenSocketOffline(obj.mac));
    });

    return () => {
      // Clean up listeners and disconnect to avoid duplicate handlers on hot reload
      try {
        socket.removeAllListeners();
        socket.disconnect();
      } catch (e) {
        console.error('Error cleaning up socket', e);
      }
    };
  }, []);
  return loading ? (<>
    <Box
      sx={{
        minHeight: "100vh",
        maxWidth: "100vw",
        backgroundImage: `url(/images/notiz-logo.png)`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "contain",
        position: "relative",
        margin: 0,
        padding: 0,
        boxSizing: "border-box",
      }}
    >
      <Box sx={{
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <Loader />
      </Box>
    </Box>

  </>) : (
    <div className="App">
      <Toaster
        position={"top-right"}
        toastOptions={{
          duration: 3000,
        }}
      />
      {/* <BrowserRouter> */}
        <Routes>
          <Route exact path={"/changepassword/:id/:token"} element={<ChangePassword />} />
          <Route exact path={"/forgetpassword"} element={<ForgetPassword />} />
          <Route exact path={'/privacypolicy'} element={<PrivacyPolicy />} />
          <Route exact path={"/login"} element={<Login />} />
          <Route exact path={"/register"} element={<Register />} />
          <Route element={<PrivateRouter />}>
            <Route
              exact
              path={"/"}
              element={<Dashboard user={user} socketRef={socketRef} />}
            />
            <Route
              exact
              path={"/layout"}
              element={<LayoutList user={user} socketRef={socketRef} />}
            />
            <Route exact path={"/design-editor"} element={<DesignEditor />} />
            <Route
              exact
              path={"/content"}
              element={<Content user={user} socketRef={socketRef} />}
            />
            <Route exact path={"/user"} element={<User user={user} socketRef={socketRef} />} />
            <Route
              exact
              path={"/screen"}
              element={<Screen user={user} socketRef={socketRef} />}
            />
            <Route
              exact
              path={"/playlist"}
              element={<Playlist user={user} auth={auth} socketRef={socketRef} />}
            />
            <Route
              exact
              path={"/playlist/:id"}
              element={<PlaylistDetails user={user} socketRef={socketRef} />}
            />
            <Route
              exact
              path={"/playlist-player/:id"}
              element={<PlaylistPlayer />}
            />

            <Route
              exact
              path={"/user-panel/:id"}
              element={<UserPanel user={user} socketRef={socketRef} />}
            />
            <Route exact path={"/apk"} element={<ApkManage user={user} />} />
            <Route exact path={"/bandwidth"} element={<ScreenBandwidth user={user} />} />
            <Route
              exact
              path={"/setting/:id"}
              element={<Setting user={user} socketRef={socketRef} />}
            />
            {/* <Route
            exact
            path={"/sharing/:id"}
            element={<Sharing user={user} socketRef={socketRef} />}
          /> */}
          </Route>
        </Routes>
      {/* </BrowserRouter> */}
    </div>
  );
}
function PrivateRouter() {
  const { auth } = useSelector((state) => state.User);
  return (
    <>
      {auth ? <Outlet /> : <Navigate to={'/login'} />}
    </>
  )
}
export default App;
